import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {InputfilteringSearch, ServiceCategory, ServiceCategoryInput} from './service-category.model';

export const loadServiceCategorys = createAction(
  '[ServiceCategory/API] Load ServiceCategorys',
  props<{ serviceCategorys: ServiceCategory[] }>()
);

export const addServiceCategory = createAction(
  '[ServiceCategory/API] Add ServiceCategory',
  props<{ serviceCategory: ServiceCategory }>()
);

export const upsertServiceCategory = createAction(
  '[ServiceCategory/API] Upsert ServiceCategory',
  props<{ serviceCategory: ServiceCategory }>()
);

export const addServiceCategorys = createAction(
  '[ServiceCategory/API] Add ServiceCategorys',
  props<{ serviceCategorys: ServiceCategory[] }>()
);

export const upsertServiceCategorys = createAction(
  '[ServiceCategory/API] Upsert ServiceCategorys',
  props<{ serviceCategorys: ServiceCategory[] }>()
);

export const updateServiceCategory = createAction(
  '[ServiceCategory/API] Update ServiceCategory',
  props<{ serviceCategory: Update<ServiceCategory> }>()
);

export const updateServiceCategorys = createAction(
  '[ServiceCategory/API] Update ServiceCategorys',
  props<{ serviceCategorys: Update<ServiceCategory>[] }>()
);

export const deleteServiceCategory = createAction(
  '[ServiceCategory/API] Delete ServiceCategory',
  props<{ id: string }>()
);

export const deleteServiceCategorys = createAction(
  '[ServiceCategory/API] Delete ServiceCategorys',
  props<{ ids: string[] }>()
);

export const clearServiceCategorys = createAction(
  '[ServiceCategory/API] Clear ServiceCategorys'
);

// CUSTOM
export const createServiceCategory = createAction(
  '[ServiceCategory/API] Create ServiceCategory',
  props<{ input: ServiceCategoryInput }>()
);

export const editServiceCategory = createAction(
  '[ServiceCategory/API] Edit ServiceCategory',
  props<{ input: ServiceCategoryInput }>()
);

export const removeServiceCategory = createAction(
  '[ServiceCategory/API] Remove ServiceCategory',
  props<{ categoryUniqueId: string, id: string }>()
);

export const getServiceCategories = createAction(
  '[ServiceCategory/API] get Service Categories',
  props<{filtering:InputfilteringSearch}>(),
);
